import { render, staticRenderFns } from "./Signatories.vue?vue&type=template&id=2a465180"
import script from "./Signatories.vue?vue&type=script&lang=js"
export * from "./Signatories.vue?vue&type=script&lang=js"
import style0 from "./Signatories.vue?vue&type=style&index=0&id=2a465180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports